// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/react-scripts/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ==================== MAIN CONTAINER ==================== */

.hs-container {
    width: 100%;
    height: auto;
    min-height: 500px;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    background: rgba(0, 0, 0, 0.02);
    border-radius: 12px;
    padding: 1rem;
    box-sizing: border-box;
  }
  
  /* ==================== PRIMARY SECTION (60% Height) ==================== */
  
  .hs-primary-section {
    width: 100%;
    height: 60%;
    min-height: 300px;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(0, 0, 0, 0.03);
    border-radius: 12px;
    overflow: hidden;
    position: relative;
  }
  
  .hs-primary-media {
    width: 100%;
    height: 100%;
    object-fit: contain;
    display: block;
  }
  
  .hs-primary-audio {
    width: 100%;
    padding: 2rem;
    display: flex;
    flex-direction: column;
    gap: 1rem;
    align-items: center;
    justify-content: center;
  }
  
  .hs-primary-audio audio {
    width: 100%;
    max-width: 500px;
  }
  
  /* ==================== SECONDARY SECTION (40% Height) ==================== */
  
  .hs-secondary-section {
    width: 100%;
    height: 40%;
    min-height: 160px;
    display: flex;
    align-items: center;
    gap: 1rem;
    position: relative;
  }
  
  /* ==================== THUMBNAILS (ONLY 3 VISIBLE) ==================== */
  
  .hs-thumbnails-wrapper {
    flex: 1 1;
    display: flex;
    gap: 1rem;
    overflow-x: auto;
    overflow-y: hidden;
    scroll-behavior: smooth;
    padding: 0.5rem;
    
    /* Hide scrollbar */
    scrollbar-width: none;
    -ms-overflow-style: none;
  }
  
  .hs-thumbnails-wrapper::-webkit-scrollbar {
    display: none;
  }
  
  /* ✅ EACH THUMBNAIL TAKES 1/3 OF AVAILABLE SPACE */
  .hs-thumbnail-item {
    flex-shrink: 0;
    width: calc((100% - 2rem) / 3); /* 3 items minus 2 gaps */
    height: 100%;
    min-height: 120px;
    max-height: 150px;
    border-radius: 8px;
    overflow: hidden;
    cursor: pointer;
    border: 2px solid transparent;
    transition: all 0.3s ease;
    position: relative;
    background: rgba(0, 0, 0, 0.05);
  }
  
  .hs-thumbnail-item:hover {
    transform: scale(1.05);
    border-color: rgba(0, 0, 0, 0.2);
    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.15);
  }
  
  .hs-thumbnail-selected {
    border: 3px solid #6c757d !important;
    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2),
                0 0.5rem 1.5rem rgba(0, 0, 0, 0.2) !important;
    transform: scale(1.02);
  }
  
  .hs-thumbnail-media {
    width: 100%;
    height: 100%;
    object-fit: cover;
    display: block;
    pointer-events: none;
  }
  
  /* Thumbnail Video */
  .hs-thumbnail-video-wrapper {
    position: relative;
    width: 100%;
    height: 100%;
  }
  
  .hs-thumbnail-video-wrapper video {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }
  
  .hs-video-play-icon {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    width: 3rem;
    height: 3rem;
    background: rgba(0, 0, 0, 0.7);
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    color: white;
    font-size: 1.25rem;
    pointer-events: none;
  }
  
  /* Thumbnail Audio */
  .hs-thumbnail-audio {
    width: 100%;
    height: 100%;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 0.5rem;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
    pointer-events: none;
  }
  
  .hs-audio-icon {
    font-size: 3rem;
  }
  
  .hs-audio-label {
    font-size: 0.875rem;
    font-weight: bold;
    color: white;
    text-transform: uppercase;
    letter-spacing: 0.05em;
  }
  
  /* ==================== SCROLL BUTTONS ==================== */
  
  .hs-scroll-button {
    flex-shrink: 0;
    width: 40px;
    height: 40px;
    border: none;
    background: rgba(0, 0, 0, 0.6);
    color: white;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    cursor: pointer;
    transition: all 0.3s ease;
    z-index: 10;
  }
  
  .hs-scroll-button:hover {
    background: rgba(0, 0, 0, 0.8);
    transform: scale(1.1);
  }
  
  .hs-scroll-button:active {
    transform: scale(0.95);
  }
  
  .hs-chevron-icon {
    width: 24px;
    height: 24px;
  }
  
  /* ==================== RESPONSIVE BREAKPOINTS ==================== */
  
  /* Tablet */
  @media (max-width: 768px) {
    .hs-container {
      min-height: 400px;
    }
  
    .hs-primary-section {
      min-height: 240px;
    }
  
    .hs-secondary-section {
      min-height: 140px;
    }
  
    .hs-thumbnail-item {
      width: calc((100% - 1.5rem) / 2); /* 2 items on tablet */
      min-height: 100px;
    }
  
    .hs-scroll-button {
      width: 36px;
      height: 36px;
    }
  }
  
  /* Mobile */
  @media (max-width: 480px) {
    .hs-container {
      min-height: 350px;
      gap: 0.75rem;
      padding: 0.75rem;
    }
  
    .hs-primary-section {
      min-height: 200px;
    }
  
    .hs-secondary-section {
      min-height: 120px;
    }
  
    .hs-thumbnail-item {
      width: calc((100% - 0.5rem) / 1.5); /* 1.5 items on mobile (shows next item) */
      min-height: 90px;
    }
  
    .hs-scroll-button {
      width: 32px;
      height: 32px;
    }
  
    .hs-chevron-icon {
      width: 20px;
      height: 20px;
    }
  
    .hs-thumbnails-wrapper {
      gap: 0.5rem;
    }
  }
  `, "",{"version":3,"sources":["webpack://./src/components/common/HorizontalScroll/horizontalScroll.css"],"names":[],"mappings":"AAAA,6DAA6D;;AAE7D;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,+BAA+B;IAC/B,mBAAmB;IACnB,aAAa;IACb,sBAAsB;EACxB;;EAEA,2EAA2E;;EAE3E;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;IAC/B,mBAAmB;IACnB,gBAAgB;IAChB,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,mBAAmB;IACnB,cAAc;EAChB;;EAEA;IACE,WAAW;IACX,aAAa;IACb,aAAa;IACb,sBAAsB;IACtB,SAAS;IACT,mBAAmB;IACnB,uBAAuB;EACzB;;EAEA;IACE,WAAW;IACX,gBAAgB;EAClB;;EAEA,6EAA6E;;EAE7E;IACE,WAAW;IACX,WAAW;IACX,iBAAiB;IACjB,aAAa;IACb,mBAAmB;IACnB,SAAS;IACT,kBAAkB;EACpB;;EAEA,0EAA0E;;EAE1E;IACE,SAAO;IACP,aAAa;IACb,SAAS;IACT,gBAAgB;IAChB,kBAAkB;IAClB,uBAAuB;IACvB,eAAe;;IAEf,mBAAmB;IACnB,qBAAqB;IACrB,wBAAwB;EAC1B;;EAEA;IACE,aAAa;EACf;;EAEA,kDAAkD;EAClD;IACE,cAAc;IACd,8BAA8B,EAAE,yBAAyB;IACzD,YAAY;IACZ,iBAAiB;IACjB,iBAAiB;IACjB,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;IACf,6BAA6B;IAC7B,yBAAyB;IACzB,kBAAkB;IAClB,+BAA+B;EACjC;;EAEA;IACE,sBAAsB;IACtB,gCAAgC;IAChC,8CAA8C;EAChD;;EAEA;IACE,oCAAoC;IACpC;6DACyD;IACzD,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,cAAc;IACd,oBAAoB;EACtB;;EAEA,oBAAoB;EACpB;IACE,kBAAkB;IAClB,WAAW;IACX,YAAY;EACd;;EAEA;IACE,WAAW;IACX,YAAY;IACZ,iBAAiB;EACnB;;EAEA;IACE,kBAAkB;IAClB,QAAQ;IACR,SAAS;IACT,gCAAgC;IAChC,WAAW;IACX,YAAY;IACZ,8BAA8B;IAC9B,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,YAAY;IACZ,kBAAkB;IAClB,oBAAoB;EACtB;;EAEA,oBAAoB;EACpB;IACE,WAAW;IACX,YAAY;IACZ,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,WAAW;IACX,6DAA6D;IAC7D,oBAAoB;EACtB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,mBAAmB;IACnB,iBAAiB;IACjB,YAAY;IACZ,yBAAyB;IACzB,sBAAsB;EACxB;;EAEA,6DAA6D;;EAE7D;IACE,cAAc;IACd,WAAW;IACX,YAAY;IACZ,YAAY;IACZ,8BAA8B;IAC9B,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,eAAe;IACf,yBAAyB;IACzB,WAAW;EACb;;EAEA;IACE,8BAA8B;IAC9B,qBAAqB;EACvB;;EAEA;IACE,sBAAsB;EACxB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;;EAEA,qEAAqE;;EAErE,WAAW;EACX;IACE;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,gCAAgC,EAAE,sBAAsB;MACxD,iBAAiB;IACnB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;EACF;;EAEA,WAAW;EACX;IACE;MACE,iBAAiB;MACjB,YAAY;MACZ,gBAAgB;IAClB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,iBAAiB;IACnB;;IAEA;MACE,kCAAkC,EAAE,0CAA0C;MAC9E,gBAAgB;IAClB;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;MACX,YAAY;IACd;;IAEA;MACE,WAAW;IACb;EACF","sourcesContent":["/* ==================== MAIN CONTAINER ==================== */\n\n.hs-container {\n    width: 100%;\n    height: auto;\n    min-height: 500px;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    background: rgba(0, 0, 0, 0.02);\n    border-radius: 12px;\n    padding: 1rem;\n    box-sizing: border-box;\n  }\n  \n  /* ==================== PRIMARY SECTION (60% Height) ==================== */\n  \n  .hs-primary-section {\n    width: 100%;\n    height: 60%;\n    min-height: 300px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(0, 0, 0, 0.03);\n    border-radius: 12px;\n    overflow: hidden;\n    position: relative;\n  }\n  \n  .hs-primary-media {\n    width: 100%;\n    height: 100%;\n    object-fit: contain;\n    display: block;\n  }\n  \n  .hs-primary-audio {\n    width: 100%;\n    padding: 2rem;\n    display: flex;\n    flex-direction: column;\n    gap: 1rem;\n    align-items: center;\n    justify-content: center;\n  }\n  \n  .hs-primary-audio audio {\n    width: 100%;\n    max-width: 500px;\n  }\n  \n  /* ==================== SECONDARY SECTION (40% Height) ==================== */\n  \n  .hs-secondary-section {\n    width: 100%;\n    height: 40%;\n    min-height: 160px;\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n    position: relative;\n  }\n  \n  /* ==================== THUMBNAILS (ONLY 3 VISIBLE) ==================== */\n  \n  .hs-thumbnails-wrapper {\n    flex: 1;\n    display: flex;\n    gap: 1rem;\n    overflow-x: auto;\n    overflow-y: hidden;\n    scroll-behavior: smooth;\n    padding: 0.5rem;\n    \n    /* Hide scrollbar */\n    scrollbar-width: none;\n    -ms-overflow-style: none;\n  }\n  \n  .hs-thumbnails-wrapper::-webkit-scrollbar {\n    display: none;\n  }\n  \n  /* ✅ EACH THUMBNAIL TAKES 1/3 OF AVAILABLE SPACE */\n  .hs-thumbnail-item {\n    flex-shrink: 0;\n    width: calc((100% - 2rem) / 3); /* 3 items minus 2 gaps */\n    height: 100%;\n    min-height: 120px;\n    max-height: 150px;\n    border-radius: 8px;\n    overflow: hidden;\n    cursor: pointer;\n    border: 2px solid transparent;\n    transition: all 0.3s ease;\n    position: relative;\n    background: rgba(0, 0, 0, 0.05);\n  }\n  \n  .hs-thumbnail-item:hover {\n    transform: scale(1.05);\n    border-color: rgba(0, 0, 0, 0.2);\n    box-shadow: 0 0.25rem 1rem rgba(0, 0, 0, 0.15);\n  }\n  \n  .hs-thumbnail-selected {\n    border: 3px solid #6c757d !important;\n    box-shadow: 0 0 0 2px rgba(108, 117, 125, 0.2),\n                0 0.5rem 1.5rem rgba(0, 0, 0, 0.2) !important;\n    transform: scale(1.02);\n  }\n  \n  .hs-thumbnail-media {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    display: block;\n    pointer-events: none;\n  }\n  \n  /* Thumbnail Video */\n  .hs-thumbnail-video-wrapper {\n    position: relative;\n    width: 100%;\n    height: 100%;\n  }\n  \n  .hs-thumbnail-video-wrapper video {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n  }\n  \n  .hs-video-play-icon {\n    position: absolute;\n    top: 50%;\n    left: 50%;\n    transform: translate(-50%, -50%);\n    width: 3rem;\n    height: 3rem;\n    background: rgba(0, 0, 0, 0.7);\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: white;\n    font-size: 1.25rem;\n    pointer-events: none;\n  }\n  \n  /* Thumbnail Audio */\n  .hs-thumbnail-audio {\n    width: 100%;\n    height: 100%;\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 0.5rem;\n    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\n    pointer-events: none;\n  }\n  \n  .hs-audio-icon {\n    font-size: 3rem;\n  }\n  \n  .hs-audio-label {\n    font-size: 0.875rem;\n    font-weight: bold;\n    color: white;\n    text-transform: uppercase;\n    letter-spacing: 0.05em;\n  }\n  \n  /* ==================== SCROLL BUTTONS ==================== */\n  \n  .hs-scroll-button {\n    flex-shrink: 0;\n    width: 40px;\n    height: 40px;\n    border: none;\n    background: rgba(0, 0, 0, 0.6);\n    color: white;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    cursor: pointer;\n    transition: all 0.3s ease;\n    z-index: 10;\n  }\n  \n  .hs-scroll-button:hover {\n    background: rgba(0, 0, 0, 0.8);\n    transform: scale(1.1);\n  }\n  \n  .hs-scroll-button:active {\n    transform: scale(0.95);\n  }\n  \n  .hs-chevron-icon {\n    width: 24px;\n    height: 24px;\n  }\n  \n  /* ==================== RESPONSIVE BREAKPOINTS ==================== */\n  \n  /* Tablet */\n  @media (max-width: 768px) {\n    .hs-container {\n      min-height: 400px;\n    }\n  \n    .hs-primary-section {\n      min-height: 240px;\n    }\n  \n    .hs-secondary-section {\n      min-height: 140px;\n    }\n  \n    .hs-thumbnail-item {\n      width: calc((100% - 1.5rem) / 2); /* 2 items on tablet */\n      min-height: 100px;\n    }\n  \n    .hs-scroll-button {\n      width: 36px;\n      height: 36px;\n    }\n  }\n  \n  /* Mobile */\n  @media (max-width: 480px) {\n    .hs-container {\n      min-height: 350px;\n      gap: 0.75rem;\n      padding: 0.75rem;\n    }\n  \n    .hs-primary-section {\n      min-height: 200px;\n    }\n  \n    .hs-secondary-section {\n      min-height: 120px;\n    }\n  \n    .hs-thumbnail-item {\n      width: calc((100% - 0.5rem) / 1.5); /* 1.5 items on mobile (shows next item) */\n      min-height: 90px;\n    }\n  \n    .hs-scroll-button {\n      width: 32px;\n      height: 32px;\n    }\n  \n    .hs-chevron-icon {\n      width: 20px;\n      height: 20px;\n    }\n  \n    .hs-thumbnails-wrapper {\n      gap: 0.5rem;\n    }\n  }\n  "],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
